




























































































import Vue from "vue";
import Component from "vue-class-component";
import User from "@/User";
import { LoggedInDiscordUser, CommunityInterface } from "@/types";
import { RankIcon } from "@/types/DiscordUserInterface";
import Discord from "@/Discord";

@Component({
  metaInfo: {
    title: "Profile – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "View and manage your Newfound Pioneer Corps profile." },
      { vmid: "og:title", property: "og:title", content: "Profile – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "View and manage your Newfound Pioneer Corps profile." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/profile" },
    ],
  },
})
export default class Profile extends Vue {

  get user(): LoggedInDiscordUser | null {
    // tslint:disable-next-line:no-unused-expression
    this.userDataKey;
    return User.get();
  }

  get displayName(): string {
    if (!this.user) { return ""; }
    return this.user.globalName || this.user.username;
  }

  get avatarUri(): string {
    if (!this.user) { return ""; }
    return Discord.avatarSourceUri(this.user.id, this.user.avatar);
  }

  get communityItems() {
    return this.communities.map((c) => ({ text: c.name, value: c.id }));
  }
  private saving: boolean = false;
  private userDataKey: number = 0;
  private communities: CommunityInterface[] = [];
  private loadingCommunities: boolean = false;
  private savingCommunity: boolean = false;
  private selectedCommunityId: number | null = null;

  public mounted() {
    if (!this.user) {
      this.$router.push("/");
    }
    this.selectedCommunityId = (this.user && this.user.community) ? this.user.community.id : null;
    this.loadCommunities();
  }

  public isSelected(icon: RankIcon): boolean {
    return this.user?.selectedIcon?.id === icon.id;
  }

  public async saveCommunity() {
    if (!this.user) { return; }
    this.savingCommunity = true;
    try {
      await this.axios.patch(`/users/discordUsers/${this.user.id}`, {
        community: this.selectedCommunityId,
      });
      const stored = JSON.parse(localStorage.getItem("user") || "{}");
      const community = this.selectedCommunityId === null
        ? null
        : (this.communities.find((c) => c.id === this.selectedCommunityId) || null);
      stored.community = community;
      localStorage.setItem("user", JSON.stringify(stored));
      this.userDataKey++;
      this.$store.dispatch("notifyUserDataChanged");
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to update community.");
    } finally {
      this.savingCommunity = false;
    }
  }

  public getIconUrl(filename: string): string {
    try {
      return require(`@/assets/images/icons/${filename}.svg`);
    } catch {
      return "";
    }
  }

  public formatFilename(filename: string): string {
    return filename
      .replace(/^rank_/, "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  public async selectIcon(icon: RankIcon) {
    if (this.isSelected(icon)) { return; }
    await this.patchIcon(icon.id);
  }

  public async clearIcon() {
    await this.patchIcon(null);
  }

  private async loadCommunities() {
    this.loadingCommunities = true;
    try {
      const response = await this.axios.get("/community/communities");
      this.communities = response.data;
    } catch {
      // silently ignore
    } finally {
      this.loadingCommunities = false;
    }
  }

  private async patchIcon(iconId: number | null) {
    if (!this.user) { return; }
    this.saving = true;
    try {
      await this.axios.patch(`/users/discordUsers/${this.user.id}`, {
        selectedIcon: iconId,
      });
      const stored = JSON.parse(localStorage.getItem("user") || "{}");
      const icons = this.user.unlockedIcons || [];
      stored.selectedIcon = iconId === null
        ? null
        : (icons.find((i) => i.id === iconId) || null);
      localStorage.setItem("user", JSON.stringify(stored));
      this.userDataKey++;
      this.$store.dispatch("notifyUserDataChanged");
    } catch {
      this.$store.dispatch("showErrorSnackbar", "Failed to update icon.");
    } finally {
      this.saving = false;
    }
  }
}
